import React from 'react';
import {PropTypes} from 'prop-types';
import HrbTranslate from '../language/HrbTranslate';
import './CardWidget.scss';

const CardWidgetErrorsContainer = (props) => (
    <div>
        {props.errorMessage &&
        <div className="hrb-card-widget-errors-container">
            <div className="hrb-card-widget-errors-line">
                <HrbTranslate text={props.errorMessage} params={props.errorMessageParams}/>
            </div>
        </div>
        }
    </div>
);

CardWidgetErrorsContainer.propTypes = {
    errorMessage: PropTypes.string,
    errorMessageParams: PropTypes.object
};

export default CardWidgetErrorsContainer